import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from './features/auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'bsd-blueprint';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // Inicializar permisos si el usuario ya está autenticado
    const userData = localStorage.getItem('userData');
    if (userData) {
      this.authService.initializeUserPermissions();
    }
  }
}
